import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const ListBuilder = () => (
  <ComponentDocs
    name="<ListBuilder/>"
    entry="ListBuilder"
    propsEntry="ListBuilderProps"
  >
    <ComponentExample
      name="List array data"
      import={import("examples/Builders/ListBuilder/ListArrayDataExample")}
      rawImport={import(
        "examples/Builders/ListBuilder/ListArrayDataExample?raw"
      )}
    />
    {/* TODO list paginated data / load more */}
    {/* TODO list with filters */}
    <ComponentExample
      name="List with table and selection"
      import={import(
        "examples/Builders/ListBuilder/ListWithTableAndSelectionExample"
      )}
      rawImport={import(
        "examples/Builders/ListBuilder/ListWithTableAndSelectionExample?raw"
      )}
    />
    <ComponentExample
      name="List with tiles"
      import={import("examples/Builders/ListBuilder/ListWithTilesExample")}
      rawImport={import(
        "examples/Builders/ListBuilder/ListWithTilesExample?raw"
      )}
    />
    {/* TODO persisting filters */}
  </ComponentDocs>
);

export default ListBuilder;
